/* tslint:disable */
/* eslint-disable */
export enum WorkConnectorTargetEntityEnum {
  Contact = 'contact',
  Container = 'container',
  Project = 'project',
  Item = 'item',
  Debtor = 'debtor',
  User = 'user',
  Absence = 'absence',
  Timerecord = 'timerecord',
  TimerecordDetail = 'timerecord_detail',
  Task = 'task',
  Document = 'document',
  Comment = 'comment',
  Interaction = 'interaction',
  LedgerAccount = 'ledger_account',
  CostCentre = 'cost_centre',
  TaxCode = 'tax_code',
  AccountingPartner = 'accounting_partner',
  PaymentCondition = 'payment_condition',
  AccountingPartnerPaymentMethod = 'accounting_partner_payment_method'
}
